import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { colors } from 'theme/default'
import { inputStyle, LabelElement, hasValue } from 'components/Input'
import IconTriangle from 'components/Icons/IconTriangle'
import { H4 } from 'components/Typo'
import Select from './Select'

const StyledSelect = styled(Select)`
  ${inputStyle}
`

const SelectWithLabel = ({ label: selectLabel, name, ...props }) => (
  <StyledSelect
    Icon={IconTriangle}
    renderSelected={({ value, label }) => (
      <React.Fragment>
        <LabelElement htmlFor={name} focus={hasValue(value)}>{selectLabel}</LabelElement>
        <H4 color={colors.text}>{label}</H4>
      </React.Fragment>
    )}
    name={name}
    {...props}
  />
)

SelectWithLabel.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

export default SelectWithLabel
